module.exports = __webpack_public_path__ + "static/img/logo.68dae66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 4Uwr
// module chunks = 1